export enum Status {
  DRAFT = 'DRAFT',
  ACTIVATED = 'ACTIVATED',
  CANCELLED = 'CANCELLED',
  REGISTERED = 'REGISTERED',
  EXPIRED = 'EXPIRED',
  VOID = 'VOID',
}

/** A filter-only value for warranties whose frozen flag is set. */
export const FROZEN_STATUS_FILTER = 'FROZEN' as const;

/**
 * Values accepted by the warranties status filter. Frozen is not a lifecycle
 * status, but is presented alongside statuses so users can find frozen warranties.
 */
export type StatusFilter = Status | typeof FROZEN_STATUS_FILTER;

/**
 * Maps  warranty status enums to user facing display labels
 */
export const STATUS_LABELS: Record<Status | 'VOID', string> = {
  DRAFT: 'PENDING',
  ACTIVATED: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  REGISTERED: 'REGISTERED',
  VOID: 'VOID',
};

//   Get the UI label for a warranty status
export function getStatusLabel(status: Status | 'VOID' | string): string {
  if (!status) return status;
  const upperStatus = status.toUpperCase() as Status | 'VOID';
  return STATUS_LABELS[upperStatus] || status;
}

/** Statuses where the warranty is no longer in force. */
export const ENDED_STATUSES: ReadonlyArray<Status> = [Status.CANCELLED, Status.EXPIRED, Status.VOID];

export function isEnded(status: Status): boolean {
  return ENDED_STATUSES.includes(status);
}
